import styled from '@emotion/styled';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { isPolicyRoute } from '../assessment/helper';
import GovernanceRightNav from '../dashboard/governance/right-nav';

import AddProjectPolicyRightPanel from '~/client/components/add-project-policy/right-panel';
import AssessmentRightPanel from '~/client/components/assessment/right-panel';
import { useLeftNavContext } from '~/client/components/base/left-nav';
import AssessmentReportRightPanel from '~/client/components/report-generator/right-panel-assessment';
import ProjectReportRightPanel from '~/client/components/report-generator/right-panel-executive';
import {
  projectRouteUtil,
  assessmentRouteUtil,
  assessmentReportRouteUtil,
  projectReportRouteUtil,
  projectMembersRouteUtil,
  governanceRoutesUtil,
  assuranceLibraryRoutesUtil,
} from '~/client/routes';
import ProjectRightPanel from '~c/components/project/right-panel';

interface Props {
  className?: string;
}

const RightPanelImpl: React.FC<Props> = () => {
  const { state } = useLeftNavContext();
  const { currentRoute } = state;
  const location = useLocation();

  if (isPolicyRoute(currentRoute, location.pathname)) {
    return <AddProjectPolicyRightPanel />;
  }
  switch (currentRoute) {
    case projectRouteUtil.routePrefix:
      return <ProjectRightPanel />;
    case projectMembersRouteUtil.routePrefix:
      return <ProjectRightPanel showMember />;
    case assessmentRouteUtil.routePrefix:
      return <AssessmentRightPanel />;
    case assessmentReportRouteUtil.routePrefix:
      return <AssessmentReportRightPanel />;
    case projectReportRouteUtil.routePrefix:
      return <ProjectReportRightPanel />;
    case governanceRoutesUtil.routePrefix:
      return <GovernanceRightNav />;
    case assuranceLibraryRoutesUtil.routePrefix:
      return <GovernanceRightNav />;
    default:
      return null;
  }
};

const RightPanel = styled(RightPanelImpl)``;

export default RightPanel;
